import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialProofPanel = () => {
  const clientLogos = [
    { name: 'Department of Health', icon: 'Building2' },
    { name: 'Education Ministry', icon: 'GraduationCap' },
    { name: 'Bank South Pacific', icon: 'Landmark' },
    { name: 'PNG Power', icon: 'Zap' },
    { name: 'Oil Search', icon: 'Droplet' },
    { name: 'Digicel PNG', icon: 'Smartphone' },
    { name: 'Air Niugini', icon: 'Plane' },
    { name: 'PNG Ports', icon: 'Anchor' }
  ];

  const certifications = [
    {
      name: 'PNG Employment Act 1978 Compliant',
      icon: 'Shield',
      color: 'emerald',
      description: 'Fully compliant with PNG employment regulations'
    },
    {
      name: 'NASFUND Integration Certified',
      icon: 'CheckCircle',
      color: 'blue',
      description: 'Official NASFUND integration partner'
    }
  ];

  const stats = [
    { value: '50+', label: 'PNG Organizations', icon: 'Building2' },
    { value: '25,000+', label: 'Employees Managed', icon: 'Users' },
    { value: '98%', label: 'Customer Satisfaction', icon: 'Heart' },
    { value: 'K12M+', label: 'Annual Savings Generated', icon: 'TrendingUp' }
  ];

  return (
    <div className="space-y-6 mb-8">
      {/* Stats Bar */}
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="flex items-center justify-center mb-2">
                <Icon name={stat?.icon} size={24} className="text-emerald-600 dark:text-emerald-400" />
              </div>
              <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">{stat?.value}</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">{stat?.label}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Certifications & Trust Badges */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {certifications?.map((cert, index) => (
          <div
            key={index}
            className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-5 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start gap-3">
              <div
                className={`w-12 h-12 bg-${cert?.color}-100 dark:bg-${cert?.color}-900/20 rounded-lg flex items-center justify-center flex-shrink-0`}
              >
                <Icon name={cert?.icon} size={24} className={`text-${cert?.color}-600 dark:text-${cert?.color}-400`} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">{cert?.name}</h4>
                <p className="text-xs text-gray-600 dark:text-gray-400">{cert?.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialProofPanel;